angular.module('elogbooksDirectives').directive('assetType', ['apiClient', 'lodash', 'NestedArrayTransformer', function (apiClient, lodash, NestedArrayTransformer) {
    return {
        require: ['ngModel'],
        scope: {
            type: '=ngModel'
        },
        templateUrl: '/modules/directives/form-elements/asset-type/asset-type.html',
        link: function(scope){
            scope.options = [];
            apiClient.get('/assettypes?page=1&limit=999999').then(function(Response) {
                var assettypes = NestedArrayTransformer.transform(Response.getData().assettypes);
                scope.options = extractOptions(assettypes);
            });
            var extractOptions = function(grouplist, parentName) {
                var elements = [];
                if (parentName == undefined) {
                    parentName = '';
                }
                lodash.each(grouplist, function (element) {
                    element.name = parentName + element.name;
                    elements.push({
                        id: element.id,
                        name: element.name,
                        reference: element.reference,
                        href: element._links.self.href
                    });
                    if (element.children) {
                        elements = elements.concat(extractOptions(element.children, element.name + ' / '));
                    }
                })
                return elements;
            }
        }
    }
}]);
